// Status binarizado pro atendente: Conectado (verde) ou Desconectado (vermelho).
// O backend ja entrega 'connected'/'disconnected'; aceitamos tambem o legado da
// Evolution ('open') por seguranca durante rolling-deploy (frontend novo + backend antigo).
// Sprint REBRANDING-BRUZAP.2 (tudo azul): conectado usa n-blue (era n-teal verde);
// desconectado segue n-ruby (vermelho).

export const isConnected = status => status === 'connected' || status === 'open';

export const labelFor = status => (isConnected(status) ? 'Conectado' : 'Desconectado');

export const dotClassFor = status =>
  isConnected(status) ? 'bg-n-blue-9' : 'bg-n-ruby-9';

export const pillClassFor = status =>
  isConnected(status)
    ? 'bg-n-blue-5/40 text-n-blue-11'
    : 'bg-n-ruby-5/40 text-n-ruby-11';
